// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fYfp3","rootMobile":"styles_rootMobile__tT0gt"};